<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_layers"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Tag <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-text :label="'slug'" v-model="resource.slug"></form-text>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-text :translate-key="'name'" :translations="resource.translations"  :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                      <form-textarea :translate-key="'description'" :translations="resource.translations" :lang="client.id" :label="'Description'" v-model="resource.translations[client.id].description"></form-textarea>
                                  </div>
                                </div>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import TagService from './TagService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                types: []
            }
        },
        mounted: function(){

        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','description']);
                this.initialize()
            },
            getResource: function(){
                return TagService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/tag/Edit.vue